// internal

// owned
import ConsoleProvider from './console-log-provider.js'

// module vars
const provider = new ConsoleProvider()

export default provider
